import {
  Alert,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Typography
} from "@mui/material"
import { useRouter } from "next/router"
import { useForm } from "react-hook-form"
import { toast } from "react-toastify"
import useGetUserProfile from "../../../../../hooks/useGetUserProfile"
import requests from "../../../../../services/requests"
import { commaSep, remSep } from "../../../../common/inputs/helper"
import ValidationHelperText from "../../../../common/validation-helper-text"
import DetailList from "../../../../detailList/DetailList"
import Pages from "src/constants/pages"
import { useState } from "react"

function FormDialog({ open, setOpen, setDisableAction, firstWatch, companyList, detailsDialog }) {
  const router = useRouter()
  const { transferCredit } = requests
  const selectedCompany = companyList?.find(x => x.id === firstWatch("company"))
  // let creditLayerId = {
  //   id: "",
  //   label: "",
  //   userCardId: ""
  // }

  const [statusDialogOpen, setStatusDialogOpen] = useState(false);
  const [statusDialogType, setStatusDialogType] = useState<"success" | "error">("success");
  const [statusDialogMessage, setStatusDialogMessage] = useState("");

  const { data: creditLayer } = useGetUserProfile()
  // const selectedCredit = creditLayer?.credits.find(credit => +credit.creditLayerId === +firstWatch("creditLayerId"))

  // if (selectedCredit) {
  //   creditLayerId = {
  //     id: selectedCredit?.creditLayerId,
  //     label: selectedCredit?.title,
  //     userCardId: selectedCredit?.userCardId
  //   }
  // }

  const {
    handleSubmit: handleSecondSubmit,
    register: secondRegister,
    formState: { errors: secondErrors },
    reset
  } = useForm()

  const handleRequest = value => {
    setDisableAction(true)
    const tempData = {
      amount: remSep(firstWatch("amount")),
      type: firstWatch("company"),
      userCardId: detailsDialog.userCardId,
      creditLayerId: detailsDialog.creditLayerId
    }
    transferCredit(tempData).then(response => {
      if (response?.status === 200) {
        if (!response?.data?.succeed) {
          setStatusDialogType("error");
          setStatusDialogMessage(response?.data?.message || "خطایی در انتقال اعتبار پیش آمد");
          setStatusDialogOpen(true);
          setDisableAction(false);
        } else {
          setStatusDialogType("success");
          setStatusDialogMessage(response?.data?.message || "درخواست انتقال اعتبار ثبت شد");
          setStatusDialogOpen(true);
          setDisableAction(true);
        }
      }
    })
  }
  return (
    <div>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          <Typography variant='h4'>تایید نهایی انتقال اعتبار</Typography>
        </DialogTitle>
        <form onSubmit={handleSecondSubmit(handleRequest)}>
          <DialogContent>
            <Typography variant='h6'>
              انتقال اعتبار از جت وام به سایر پذیرندگان، قطعی و غیر قابل برگشت است . لطفا قبل از انتقال اعتبار از انجام
              آن اطمینان حاصل نمایید.
            </Typography>
            <DetailList
              items={[
                {
                  title: "مبلغ در حال انتقال(به عدد)",
                  value: <Typography>{firstWatch("amount") && commaSep(firstWatch("amount"))}</Typography>
                },
                {
                  title: "مقصد انتقال (پذیرنده)",
                  value: <Typography>{selectedCompany?.name}</Typography>
                },
                {
                  title: "لایه اعتباری انتخاب شده",
                  value: <Typography>{detailsDialog?.title || ""}</Typography>
                }
              ]}
            />

            {selectedCompany?.description && selectedCompany?.description !== "" && (
              <Box my={2}>
                <Alert severity='error'>
                  <Typography> {selectedCompany?.description}</Typography>
                </Alert>
              </Box>
            )}

            <Box ml={2}>
              <FormControlLabel
                name='rules'
                {...secondRegister("rules", {
                  required: {
                    value: true,
                    message: "پذیرش مقررات فوق الزامی است"
                  }
                })}
                control={<Checkbox />}
                label='با قوانین و مقررات انتقال اعتبار موافقت می نمایم'
              />
              <ValidationHelperText error={!!secondErrors?.rules} helperText={secondErrors?.rules?.message as string} />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button type='submit' variant='contained' color='success'>
              انتقال اعتبار
            </Button>
            <Button
              variant='contained'
              color='error'
              onClick={() => {
                setOpen(false)
                reset()
              }}
            >
              انصراف
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      <Dialog
        open={statusDialogOpen}
        onClose={() => {
          if (statusDialogType === "success") {
            router.push("/main/requests/newRequest");
          }
          setStatusDialogOpen(false);
          setOpen(false);
        }}
        aria-labelledby="status-dialog-title"
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle id="status-dialog-title">
          {statusDialogType === "success" ? "انتقال موفق" : "خطایی رخ داد"}
        </DialogTitle>
        <DialogContent>
          <Typography>{statusDialogMessage}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setStatusDialogOpen(false);
            if (statusDialogType === "success") {
              router.push("/main/requests/newRequest");
            }
            setOpen(false);
          }} autoFocus>
            متوجه شدم
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default FormDialog
